import Axios from "./axios";
import type { IFilters, IPagination2, ISorting } from "../interfaces/Components/ITable";

export function cleanDataLoader2Filters(
  filters?: Record<string, IFilters>
): Record<string, IFilters> {
  const cleaned: Record<string, IFilters> = {};
  for (const key in filters || {}) {
    const f = (filters as any)[key] as IFilters | undefined;
    const v: any = (f as any)?.value;
    if (v === "" || v === undefined) {
      continue;
    }
    if (Array.isArray(v) && v.length === 0) {
      continue;
    }
    if (f) {
      cleaned[key] = f;
    }
  }
  return cleaned;
}

export function buildDataLoader2Url(args: {
  endpoint: string;
  filter?: Record<string, IFilters>;
  sort?: ISorting;
  pagination: IPagination2;
  fields?: string[];
}): string {
  const params = new URLSearchParams();
  if (args.fields?.length) {
    params.append("fields", JSON.stringify(args.fields));
  }

  const cleaned = cleanDataLoader2Filters(args.filter);
  if (Object.keys(cleaned).length > 0) {
    params.append("filter", JSON.stringify(cleaned));
  }

  if (args.sort && args.sort.order !== undefined && args.sort.order !== null) {
    params.append("sort", JSON.stringify(args.sort));
  }

  params.append("pagination", JSON.stringify(args.pagination));
  return `${args.endpoint}?${params.toString()}`;
}

export async function exportAllDataLoader2<T>(args: {
  endpoint: string;
  filter?: Record<string, IFilters>;
  sort?: ISorting;
  pageSize?: number;
  fields?: string[];
  axios?: Axios;
}): Promise<T[]> {
  const client = args.axios ?? new Axios();
  const pageSize = args.pageSize ?? 1000;

  let pageIndex = 0;
  const allRows: T[] = [];

  while (true) {
    const url = buildDataLoader2Url({
      endpoint: args.endpoint,
      filter: args.filter,
      sort: args.sort,
      fields: args.fields,
      pagination: { pageIndex, pageSize },
    });

    const response = await client.Get(url);
    const chunk = response?.data;
    if (!Array.isArray(chunk)) {
      break;
    }

    allRows.push(...(chunk as T[]));
    if (chunk.length < pageSize) {
      break;
    }
    pageIndex += 1;
  }

  return allRows;
}

